var map = {
	"./1.png": 91181,
	"./10.png": 10589,
	"./100.png": 8282,
	"./1000.png": 19426,
	"./10001.png": 34789,
	"./10002.png": 24665,
	"./10003.png": 11289,
	"./10004.png": 74758,
	"./10005.png": 509,
	"./10006.png": 35640,
	"./10007.png": 93210,
	"./10008.png": 78648,
	"./10009.png": 2781,
	"./1001.png": 17238,
	"./10010.png": 54655,
	"./10011.png": 65099,
	"./10012.png": 74839,
	"./10013.png": 29926,
	"./10014.png": 75871,
	"./10015.png": 43933,
	"./10016.png": 60240,
	"./10017.png": 74233,
	"./10018.png": 91832,
	"./10019.png": 63188,
	"./1002.png": 87248,
	"./10020.png": 25484,
	"./10021.png": 41354,
	"./10022.png": 58347,
	"./10023.png": 89863,
	"./10024.png": 36164,
	"./10025.png": 24196,
	"./10026.png": 70467,
	"./10027.png": 2361,
	"./10028.png": 33018,
	"./10029.png": 42435,
	"./1003.png": 62990,
	"./10030.png": 76017,
	"./10031.png": 97888,
	"./10032.png": 74213,
	"./10033.png": 55273,
	"./10034.png": 53909,
	"./10035.png": 63211,
	"./10036.png": 82402,
	"./10037.png": 5387,
	"./10038.png": 87713,
	"./10039.png": 700,
	"./1004.png": 25361,
	"./10040.png": 39109,
	"./10041.png": 14128,
	"./10042.png": 84278,
	"./10043.png": 23559,
	"./10044.png": 45774,
	"./10045.png": 39352,
	"./10046.png": 13878,
	"./10047.png": 85561,
	"./10048.png": 53271,
	"./10049.png": 50305,
	"./1005.png": 83192,
	"./10050.png": 18851,
	"./10051.png": 44657,
	"./10052.png": 50857,
	"./10053.png": 42853,
	"./10054.png": 44521,
	"./10055.png": 611,
	"./10056.png": 78852,
	"./10057.png": 98458,
	"./10058.png": 5489,
	"./10059.png": 19661,
	"./1006.png": 54127,
	"./10060.png": 40647,
	"./10061.png": 41091,
	"./10062.png": 1782,
	"./10063.png": 92898,
	"./10064.png": 60668,
	"./10065.png": 84901,
	"./10066.png": 30124,
	"./10067.png": 13506,
	"./10068.png": 22693,
	"./10069.png": 26712,
	"./1007.png": 46331,
	"./10070.png": 42193,
	"./10071.png": 23361,
	"./10072.png": 69583,
	"./10073.png": 50745,
	"./10074.png": 36611,
	"./10075.png": 30471,
	"./10076.png": 27897,
	"./10077.png": 41930,
	"./10078.png": 62696,
	"./10079.png": 90123,
	"./1008.png": 80691,
	"./10080.png": 89428,
	"./10081.png": 14782,
	"./10082.png": 61729,
	"./10083.png": 31897,
	"./10084.png": 74365,
	"./10085.png": 50073,
	"./10086.png": 64483,
	"./10087.png": 80961,
	"./10088.png": 13457,
	"./10089.png": 95353,
	"./10090.png": 31420,
	"./10091.png": 16071,
	"./10092.png": 43168,
	"./10093.png": 99239,
	"./10094.png": 59211,
	"./10095.png": 55477,
	"./10096.png": 76870,
	"./10097.png": 1790,
	"./10098.png": 75377,
	"./10099.png": 41034,
	"./101.png": 70882,
	"./10100.png": 7612,
	"./10101.png": 63247,
	"./10102.png": 30055,
	"./10103.png": 25938,
	"./10104.png": 17302,
	"./10105.png": 90795,
	"./10106.png": 52909,
	"./10107.png": 92000,
	"./10108.png": 23763,
	"./10109.png": 69760,
	"./10110.png": 10324,
	"./10111.png": 55601,
	"./10112.png": 74396,
	"./10113.png": 86669,
	"./10114.png": 8853,
	"./10115.png": 64646,
	"./10116.png": 6152,
	"./10117.png": 18812,
	"./10118.png": 39118,
	"./10119.png": 90896,
	"./10120.png": 81497,
	"./10121.png": 55060,
	"./10122.png": 49811,
	"./10123.png": 98786,
	"./10124.png": 53429,
	"./10125.png": 31364,
	"./10126.png": 28287,
	"./10127.png": 4256,
	"./10130.png": 57623,
	"./10131.png": 60935,
	"./10132.png": 55460,
	"./10133.png": 72121,
	"./10134.png": 51768,
	"./10135.png": 59747,
	"./10136.png": 58026,
	"./10137.png": 29058,
	"./10138.png": 88753,
	"./10139.png": 85666,
	"./10140.png": 80966,
	"./10141.png": 34818,
	"./10142.png": 99310,
	"./10143.png": 39804,
	"./10144.png": 72369,
	"./10145.png": 22852,
	"./10147.png": 29111,
	"./10148.png": 51907,
	"./10149.png": 4856,
	"./10150.png": 84913,
	"./10151.png": 61646,
	"./10152.png": 9399,
	"./10155.png": 24385,
	"./10156.png": 35180,
	"./10157.png": 98597,
	"./10161.png": 51078,
	"./10162.png": 38469,
	"./10163.png": 64650,
	"./10164.png": 31286,
	"./10165.png": 14854,
	"./10166.png": 98139,
	"./10167.png": 7346,
	"./10168.png": 5401,
	"./10169.png": 14154,
	"./10170.png": 46091,
	"./10171.png": 32709,
	"./10172.png": 37919,
	"./10173.png": 51089,
	"./10174.png": 71376,
	"./10175.png": 37987,
	"./10176.png": 20558,
	"./10177.png": 75966,
	"./10178.png": 48955,
	"./10179.png": 5978,
	"./10180.png": 48188,
	"./10184.png": 64883,
	"./10185.png": 92961,
	"./10186.png": 7465,
	"./10188.png": 82474,
	"./10189.png": 41891,
	"./10190.png": 66058,
	"./10191.png": 34525,
	"./10193.png": 26110,
	"./10194.png": 42711,
	"./10195.png": 69284,
	"./10196.png": 33262,
	"./10197.png": 94869,
	"./10198.png": 4607,
	"./10199.png": 82726,
	"./102.png": 29233,
	"./10200.png": 6411,
	"./10201.png": 96649,
	"./10202.png": 53176,
	"./10203.png": 94957,
	"./10204.png": 87203,
	"./10205.png": 75235,
	"./10206.png": 56477,
	"./10207.png": 82724,
	"./10208.png": 51535,
	"./10209.png": 30710,
	"./10210.png": 60579,
	"./10211.png": 47735,
	"./10212.png": 12787,
	"./10213.png": 57001,
	"./10214.png": 31576,
	"./10215.png": 55838,
	"./10216.png": 76876,
	"./10217.png": 33037,
	"./10218.png": 7165,
	"./10219.png": 8923,
	"./10220.png": 12111,
	"./10221.png": 90533,
	"./10222.png": 63405,
	"./10223.png": 79793,
	"./10224.png": 81212,
	"./10225.png": 3388,
	"./10226.png": 98802,
	"./10227.png": 92021,
	"./10228.png": 46767,
	"./10229.png": 92332,
	"./10230.png": 24903,
	"./10231.png": 43941,
	"./10232.png": 75639,
	"./10233.png": 85746,
	"./10234.png": 83970,
	"./10235.png": 72656,
	"./10236.png": 63915,
	"./10237.png": 94256,
	"./10238.png": 1377,
	"./10239.png": 20768,
	"./10240.png": 74601,
	"./10241.png": 94917,
	"./10242.png": 59150,
	"./10243.png": 26609,
	"./10244.png": 79812,
	"./10245.png": 63607,
	"./10246.png": 9607,
	"./10247.png": 11318,
	"./10248.png": 14624,
	"./10249.png": 56491,
	"./10250.png": 87315,
	"./10251.png": 86357,
	"./10252.png": 63183,
	"./10253.png": 9280,
	"./10254.png": 39919,
	"./10255.png": 54818,
	"./10256.png": 11046,
	"./10257.png": 63583,
	"./10258.png": 885,
	"./10259.png": 79300,
	"./10260.png": 84081,
	"./10261.png": 73358,
	"./10262.png": 43613,
	"./10263.png": 92197,
	"./103.png": 46864,
	"./104.png": 73550,
	"./105.png": 76840,
	"./106.png": 9596,
	"./107.png": 22133,
	"./108.png": 7460,
	"./109.png": 37722,
	"./11.png": 52209,
	"./110.png": 82643,
	"./111.png": 7950,
	"./112.png": 610,
	"./113.png": 13521,
	"./114.png": 75658,
	"./115-mega.png": 65702,
	"./115.png": 74346,
	"./116.png": 76492,
	"./117.png": 68063,
	"./118.png": 37657,
	"./119.png": 86588,
	"./12.png": 49134,
	"./120.png": 78917,
	"./121.png": 17897,
	"./122.png": 94725,
	"./123.png": 91109,
	"./124.png": 98985,
	"./125.png": 84116,
	"./126.png": 61295,
	"./127-mega.png": 80180,
	"./127.png": 97539,
	"./128.png": 65004,
	"./129.png": 22487,
	"./13.png": 89042,
	"./130-mega.png": 43113,
	"./130.png": 22230,
	"./131.png": 58849,
	"./132.png": 70809,
	"./133.png": 66261,
	"./134.png": 48335,
	"./135.png": 60779,
	"./136.png": 56385,
	"./137.png": 79997,
	"./138.png": 35174,
	"./139.png": 96786,
	"./14.png": 67792,
	"./140.png": 93693,
	"./141.png": 49878,
	"./142-mega.png": 23170,
	"./142.png": 37460,
	"./143.png": 30042,
	"./144.png": 70737,
	"./145.png": 11284,
	"./146.png": 78358,
	"./147.png": 76676,
	"./148.png": 76093,
	"./149.png": 19387,
	"./15-mega.png": 13496,
	"./15.png": 86517,
	"./150-mega-x.png": 61246,
	"./150-mega-y.png": 84866,
	"./150.png": 52493,
	"./151.png": 98698,
	"./152.png": 75949,
	"./153.png": 73899,
	"./154.png": 38474,
	"./155.png": 85618,
	"./156.png": 48242,
	"./157.png": 90776,
	"./158.png": 17090,
	"./159.png": 99830,
	"./16.png": 18476,
	"./160.png": 12503,
	"./161.png": 28564,
	"./162.png": 38797,
	"./163.png": 66617,
	"./164.png": 38,
	"./165.png": 19545,
	"./166.png": 78955,
	"./167.png": 83141,
	"./168.png": 70953,
	"./169.png": 95960,
	"./17.png": 30130,
	"./170.png": 37855,
	"./171.png": 92576,
	"./172.png": 81730,
	"./173.png": 31865,
	"./174.png": 3705,
	"./175.png": 22362,
	"./176.png": 43022,
	"./177.png": 1638,
	"./178.png": 39413,
	"./179.png": 74923,
	"./18-mega.png": 22385,
	"./18.png": 19647,
	"./180.png": 28726,
	"./181-mega.png": 36401,
	"./181.png": 97525,
	"./182.png": 65119,
	"./183.png": 80285,
	"./184.png": 59368,
	"./185.png": 88051,
	"./186.png": 21009,
	"./187.png": 85485,
	"./188.png": 10619,
	"./189.png": 29222,
	"./19.png": 99237,
	"./190.png": 82283,
	"./191.png": 83372,
	"./192.png": 41044,
	"./193.png": 91570,
	"./194.png": 68957,
	"./195.png": 33529,
	"./196.png": 28824,
	"./197.png": 69518,
	"./198.png": 71490,
	"./199.png": 81287,
	"./2.png": 67819,
	"./20.png": 83671,
	"./200.png": 10986,
	"./201-a.png": 65413,
	"./201-b.png": 13465,
	"./201-c.png": 38488,
	"./201-d.png": 33738,
	"./201-e.png": 79941,
	"./201-exclamation.png": 48199,
	"./201-f.png": 42997,
	"./201-g.png": 53722,
	"./201-h.png": 81444,
	"./201-i.png": 82163,
	"./201-j.png": 22417,
	"./201-k.png": 2394,
	"./201-l.png": 18286,
	"./201-m.png": 41669,
	"./201-n.png": 25447,
	"./201-o.png": 90024,
	"./201-p.png": 15177,
	"./201-q.png": 88199,
	"./201-question.png": 70395,
	"./201-r.png": 52627,
	"./201-s.png": 71726,
	"./201-t.png": 53469,
	"./201-u.png": 58183,
	"./201-v.png": 19132,
	"./201-w.png": 93120,
	"./201-x.png": 36031,
	"./201-y.png": 10248,
	"./201-z.png": 4090,
	"./201.png": 83472,
	"./202.png": 85399,
	"./203.png": 63687,
	"./204.png": 72153,
	"./205.png": 9676,
	"./206.png": 23879,
	"./207.png": 46110,
	"./208-mega.png": 35025,
	"./208.png": 14442,
	"./209.png": 17773,
	"./21.png": 1608,
	"./210.png": 33303,
	"./211.png": 31942,
	"./212-mega.png": 29047,
	"./212.png": 38110,
	"./213.png": 46954,
	"./214-mega.png": 67025,
	"./214.png": 45310,
	"./215.png": 45682,
	"./216.png": 81996,
	"./217.png": 8614,
	"./218.png": 9719,
	"./219.png": 57440,
	"./22.png": 68592,
	"./220.png": 8331,
	"./221.png": 43612,
	"./222.png": 64485,
	"./223.png": 89838,
	"./224.png": 12229,
	"./225.png": 16229,
	"./226.png": 76582,
	"./227.png": 7403,
	"./228.png": 24685,
	"./229-mega.png": 73380,
	"./229.png": 45083,
	"./23.png": 94831,
	"./230.png": 73552,
	"./231.png": 59769,
	"./232.png": 71896,
	"./233.png": 16634,
	"./234.png": 63733,
	"./235.png": 95155,
	"./236.png": 92099,
	"./237.png": 35106,
	"./238.png": 71403,
	"./239.png": 90815,
	"./24.png": 34754,
	"./240.png": 50682,
	"./241.png": 64629,
	"./242.png": 91558,
	"./243.png": 96200,
	"./244.png": 92166,
	"./245.png": 66758,
	"./246.png": 69778,
	"./247.png": 73952,
	"./248-mega.png": 42760,
	"./248.png": 51064,
	"./249.png": 61228,
	"./25.png": 93815,
	"./250.png": 636,
	"./251.png": 31698,
	"./252.png": 95597,
	"./253.png": 4164,
	"./254-mega.png": 47234,
	"./254.png": 53511,
	"./255.png": 37861,
	"./256.png": 35657,
	"./257-mega.png": 20540,
	"./257.png": 69743,
	"./258.png": 94548,
	"./259.png": 3875,
	"./26.png": 9800,
	"./260-mega.png": 27047,
	"./260.png": 10610,
	"./261.png": 24486,
	"./262.png": 92891,
	"./263.png": 96461,
	"./264.png": 5799,
	"./265.png": 70913,
	"./266.png": 9403,
	"./267.png": 31982,
	"./268.png": 35497,
	"./269.png": 73157,
	"./27.png": 91092,
	"./270.png": 87140,
	"./271.png": 86683,
	"./272.png": 76497,
	"./273.png": 39439,
	"./274.png": 14000,
	"./275.png": 77518,
	"./276.png": 79179,
	"./277.png": 23129,
	"./278.png": 57201,
	"./279.png": 63489,
	"./28.png": 76701,
	"./280.png": 14052,
	"./281.png": 46335,
	"./282-mega.png": 97039,
	"./282.png": 91453,
	"./283.png": 29619,
	"./284.png": 8095,
	"./285.png": 92966,
	"./286.png": 62036,
	"./287.png": 46175,
	"./288.png": 24194,
	"./289.png": 56406,
	"./29.png": 73032,
	"./290.png": 50551,
	"./291.png": 28912,
	"./292.png": 58694,
	"./293.png": 19904,
	"./294.png": 13260,
	"./295.png": 70963,
	"./296.png": 77321,
	"./297.png": 62702,
	"./298.png": 13002,
	"./299.png": 17886,
	"./3-mega.png": 55407,
	"./3.png": 65698,
	"./30.png": 59591,
	"./300.png": 62490,
	"./301.png": 61662,
	"./302-mega.png": 49983,
	"./302.png": 65139,
	"./303-mega.png": 47082,
	"./303.png": 67877,
	"./304.png": 99812,
	"./305.png": 51083,
	"./306-mega.png": 94275,
	"./306.png": 22613,
	"./307.png": 52661,
	"./308-mega.png": 45129,
	"./308.png": 65907,
	"./309.png": 30729,
	"./31.png": 49065,
	"./310-mega.png": 19368,
	"./310.png": 50802,
	"./311.png": 59392,
	"./312.png": 97627,
	"./313.png": 85068,
	"./314.png": 87001,
	"./315.png": 86371,
	"./316.png": 45291,
	"./317.png": 34113,
	"./318.png": 91239,
	"./319-mega.png": 97712,
	"./319.png": 74866,
	"./32.png": 37960,
	"./320.png": 55032,
	"./321.png": 77026,
	"./322.png": 89918,
	"./323-mega.png": 63815,
	"./323.png": 40118,
	"./324.png": 66567,
	"./325.png": 32514,
	"./326.png": 70459,
	"./327.png": 79271,
	"./328.png": 57247,
	"./329.png": 58025,
	"./33.png": 84290,
	"./330.png": 24231,
	"./331.png": 75318,
	"./332.png": 33915,
	"./333.png": 41197,
	"./334-mega.png": 72165,
	"./334.png": 74468,
	"./335.png": 66344,
	"./336.png": 20662,
	"./337.png": 58961,
	"./338.png": 74569,
	"./339.png": 63830,
	"./34.png": 36671,
	"./340.png": 27366,
	"./341.png": 19603,
	"./342.png": 4935,
	"./343.png": 73555,
	"./344.png": 15400,
	"./345.png": 87609,
	"./346.png": 18349,
	"./347.png": 58529,
	"./348.png": 85932,
	"./349.png": 66753,
	"./35.png": 87383,
	"./350.png": 65307,
	"./351-rainy.png": 5326,
	"./351-snowy.png": 52357,
	"./351-sunny.png": 52088,
	"./351.png": 4947,
	"./352.png": 26035,
	"./353.png": 16112,
	"./354-mega.png": 43435,
	"./354.png": 63308,
	"./355.png": 94028,
	"./356.png": 43826,
	"./357.png": 66090,
	"./358.png": 54648,
	"./359-mega.png": 44108,
	"./359.png": 16317,
	"./36.png": 10638,
	"./360.png": 21054,
	"./361.png": 63450,
	"./362-mega.png": 95934,
	"./362.png": 42689,
	"./363.png": 5891,
	"./364.png": 36345,
	"./365.png": 48997,
	"./366.png": 41689,
	"./367.png": 37036,
	"./368.png": 30966,
	"./369.png": 83689,
	"./37.png": 16871,
	"./370.png": 49039,
	"./371.png": 73413,
	"./372.png": 36263,
	"./373-mega.png": 8933,
	"./373.png": 28985,
	"./374.png": 17681,
	"./375.png": 34054,
	"./376-mega.png": 53661,
	"./376.png": 39826,
	"./377.png": 30245,
	"./378.png": 6769,
	"./379.png": 46964,
	"./38.png": 9823,
	"./380-mega.png": 61301,
	"./380.png": 32738,
	"./381-mega.png": 13249,
	"./381.png": 90427,
	"./382-primal.png": 41390,
	"./382.png": 8393,
	"./383-primal.png": 71871,
	"./383.png": 46534,
	"./384-mega.png": 48043,
	"./384.png": 22138,
	"./385.png": 41561,
	"./386-attack.png": 76400,
	"./386-defense.png": 19503,
	"./386-normal.png": 36065,
	"./386-speed.png": 17676,
	"./386.png": 81825,
	"./387.png": 7160,
	"./388.png": 67330,
	"./389.png": 41796,
	"./39.png": 55326,
	"./390.png": 46955,
	"./391.png": 80725,
	"./392.png": 53910,
	"./393.png": 58093,
	"./394.png": 90333,
	"./395.png": 3350,
	"./396.png": 57162,
	"./397.png": 39063,
	"./398.png": 85110,
	"./399.png": 24522,
	"./4.png": 79665,
	"./40.png": 55199,
	"./400.png": 94373,
	"./401.png": 53275,
	"./402.png": 38999,
	"./403.png": 41880,
	"./404.png": 43544,
	"./405.png": 5545,
	"./406.png": 4267,
	"./407.png": 59094,
	"./408.png": 37831,
	"./409.png": 75486,
	"./41.png": 95788,
	"./410.png": 6982,
	"./411.png": 82686,
	"./412-plant.png": 54856,
	"./412-sandy.png": 81745,
	"./412-trash.png": 31618,
	"./412.png": 6658,
	"./413-plant.png": 91478,
	"./413-sandy.png": 6925,
	"./413-trash.png": 19811,
	"./413.png": 29637,
	"./414-plant.png": 86212,
	"./414.png": 33294,
	"./415.png": 90287,
	"./416.png": 40401,
	"./417.png": 49783,
	"./418.png": 8792,
	"./419.png": 16424,
	"./42.png": 76162,
	"./420.png": 95433,
	"./421-overcast.png": 85481,
	"./421-sunshine.png": 66543,
	"./421.png": 61519,
	"./422-east.png": 52070,
	"./422-west.png": 72640,
	"./422.png": 60669,
	"./423-east.png": 95967,
	"./423-west.png": 2618,
	"./423.png": 48941,
	"./424.png": 10250,
	"./425.png": 3465,
	"./426.png": 33369,
	"./427.png": 2002,
	"./428-mega.png": 6575,
	"./428.png": 57735,
	"./429.png": 48694,
	"./43.png": 60844,
	"./430.png": 14530,
	"./431.png": 54866,
	"./432.png": 61756,
	"./433.png": 78232,
	"./434.png": 99037,
	"./435.png": 66016,
	"./436.png": 81593,
	"./437.png": 62346,
	"./438.png": 20105,
	"./439.png": 4599,
	"./44.png": 80262,
	"./440.png": 202,
	"./441.png": 52014,
	"./442.png": 73227,
	"./443.png": 11299,
	"./444.png": 16510,
	"./445-mega.png": 35604,
	"./445.png": 78758,
	"./446.png": 71655,
	"./447.png": 24165,
	"./448-mega.png": 38601,
	"./448.png": 75646,
	"./449.png": 32691,
	"./45.png": 61608,
	"./450.png": 95664,
	"./451.png": 73875,
	"./452.png": 19029,
	"./453.png": 50667,
	"./454.png": 4510,
	"./455.png": 86486,
	"./456.png": 27912,
	"./457.png": 99549,
	"./458.png": 22105,
	"./459.png": 65017,
	"./46.png": 37865,
	"./460-mega.png": 72428,
	"./460.png": 51332,
	"./461.png": 79630,
	"./462.png": 16770,
	"./463.png": 45117,
	"./464.png": 32601,
	"./465.png": 20918,
	"./466.png": 25695,
	"./467.png": 38851,
	"./468.png": 1419,
	"./469.png": 90788,
	"./47.png": 46345,
	"./470.png": 37610,
	"./471.png": 91120,
	"./472.png": 79845,
	"./473.png": 91236,
	"./474.png": 3171,
	"./475-mega.png": 36074,
	"./475.png": 98296,
	"./476.png": 65931,
	"./477.png": 51097,
	"./478.png": 9429,
	"./479-fan.png": 18411,
	"./479-frost.png": 32173,
	"./479-heat.png": 51779,
	"./479-mow.png": 85202,
	"./479-wash.png": 75769,
	"./479.png": 97104,
	"./48.png": 36250,
	"./480.png": 46897,
	"./481.png": 46780,
	"./482.png": 53560,
	"./483.png": 21951,
	"./484.png": 81506,
	"./485.png": 12034,
	"./486.png": 57459,
	"./487-altered.png": 57069,
	"./487-origin.png": 2705,
	"./487.png": 51620,
	"./488.png": 87965,
	"./489.png": 12965,
	"./49.png": 35566,
	"./490.png": 84251,
	"./491.png": 10214,
	"./492-land.png": 76878,
	"./492-sky.png": 73851,
	"./492.png": 63773,
	"./493-bug.png": 29257,
	"./493-dark.png": 53298,
	"./493-dragon.png": 59034,
	"./493-electric.png": 81661,
	"./493-fairy.png": 56241,
	"./493-fighting.png": 7334,
	"./493-fire.png": 70019,
	"./493-flying.png": 70522,
	"./493-ghost.png": 84457,
	"./493-grass.png": 80910,
	"./493-ground.png": 29454,
	"./493-ice.png": 50676,
	"./493-normal.png": 54521,
	"./493-poison.png": 30063,
	"./493-psychic.png": 45172,
	"./493-rock.png": 62329,
	"./493-steel.png": 67855,
	"./493-unknown.png": 57040,
	"./493-water.png": 82944,
	"./493.png": 44147,
	"./494.png": 76350,
	"./495.png": 93577,
	"./496.png": 1665,
	"./497.png": 26927,
	"./498.png": 77126,
	"./499.png": 43479,
	"./5.png": 15439,
	"./50.png": 37503,
	"./500.png": 43678,
	"./501.png": 35270,
	"./502.png": 78613,
	"./503.png": 46877,
	"./504.png": 11640,
	"./505.png": 82407,
	"./506.png": 71845,
	"./507.png": 77392,
	"./508.png": 14393,
	"./509.png": 63223,
	"./51.png": 27483,
	"./510.png": 12880,
	"./511.png": 7365,
	"./512.png": 8825,
	"./513.png": 92640,
	"./514.png": 80895,
	"./515.png": 82733,
	"./516.png": 54944,
	"./517.png": 7798,
	"./518.png": 62871,
	"./519.png": 43774,
	"./52.png": 90676,
	"./520.png": 89579,
	"./521.png": 35513,
	"./522.png": 30722,
	"./523.png": 24755,
	"./524.png": 90135,
	"./525.png": 77590,
	"./526.png": 5911,
	"./527.png": 55001,
	"./528.png": 57019,
	"./529.png": 46665,
	"./53.png": 21455,
	"./530.png": 17287,
	"./531-mega.png": 86892,
	"./531.png": 69112,
	"./532.png": 80789,
	"./533.png": 67613,
	"./534.png": 46958,
	"./535.png": 45601,
	"./536.png": 86596,
	"./537.png": 20912,
	"./538.png": 8189,
	"./539.png": 36816,
	"./54.png": 78002,
	"./540.png": 40738,
	"./541.png": 42131,
	"./542.png": 36798,
	"./543.png": 35113,
	"./544.png": 44149,
	"./545.png": 56101,
	"./546.png": 98760,
	"./547.png": 86383,
	"./548.png": 11751,
	"./549.png": 33683,
	"./55.png": 29638,
	"./550-blue-striped.png": 12641,
	"./550-red-striped.png": 58107,
	"./550.png": 86395,
	"./551.png": 85640,
	"./552.png": 77650,
	"./553.png": 80442,
	"./554.png": 39983,
	"./555-standard.png": 92528,
	"./555-zen.png": 70968,
	"./555.png": 22832,
	"./556.png": 95202,
	"./557.png": 51593,
	"./558.png": 68081,
	"./559.png": 26731,
	"./56.png": 87491,
	"./560.png": 20925,
	"./561.png": 8037,
	"./562.png": 15201,
	"./563.png": 63747,
	"./564.png": 1390,
	"./565.png": 96956,
	"./566.png": 91391,
	"./567.png": 78238,
	"./568.png": 22868,
	"./569.png": 87718,
	"./57.png": 56722,
	"./570.png": 81355,
	"./571.png": 57951,
	"./572.png": 24286,
	"./573.png": 31106,
	"./574.png": 88053,
	"./575.png": 45179,
	"./576.png": 94767,
	"./577.png": 19645,
	"./578.png": 41029,
	"./579.png": 40264,
	"./58.png": 66585,
	"./580.png": 54151,
	"./581.png": 23023,
	"./582.png": 52313,
	"./583.png": 56464,
	"./584.png": 68742,
	"./585-autumn.png": 95325,
	"./585-spring.png": 49912,
	"./585-summer.png": 40782,
	"./585-winter.png": 28520,
	"./585.png": 14693,
	"./586-autumn.png": 13908,
	"./586-spring.png": 41926,
	"./586-summer.png": 65203,
	"./586-winter.png": 26865,
	"./586.png": 28463,
	"./587.png": 48602,
	"./588.png": 51652,
	"./589.png": 95156,
	"./59.png": 57898,
	"./590.png": 94912,
	"./591.png": 90065,
	"./592.png": 37243,
	"./593.png": 85208,
	"./594.png": 86217,
	"./595.png": 78723,
	"./596.png": 4185,
	"./597.png": 36124,
	"./598.png": 79230,
	"./599.png": 74524,
	"./6-mega-x.png": 92897,
	"./6-mega-y.png": 25664,
	"./6.png": 46271,
	"./60.png": 75881,
	"./600.png": 89405,
	"./601.png": 47167,
	"./602.png": 99430,
	"./603.png": 37949,
	"./604.png": 67556,
	"./605.png": 33963,
	"./606.png": 8770,
	"./607.png": 31810,
	"./608.png": 47399,
	"./609.png": 66740,
	"./61.png": 59952,
	"./610.png": 67834,
	"./611.png": 10310,
	"./612.png": 39571,
	"./613.png": 4384,
	"./614.png": 25787,
	"./615.png": 38449,
	"./616.png": 26608,
	"./617.png": 25160,
	"./618.png": 45472,
	"./619.png": 90252,
	"./62.png": 4866,
	"./620.png": 8855,
	"./621.png": 85168,
	"./622.png": 1148,
	"./623.png": 46108,
	"./624.png": 27658,
	"./625.png": 22669,
	"./626.png": 88922,
	"./627.png": 38138,
	"./628.png": 63918,
	"./629.png": 25909,
	"./63.png": 99412,
	"./630.png": 89721,
	"./631.png": 52765,
	"./632.png": 57476,
	"./633.png": 54842,
	"./634.png": 24758,
	"./635.png": 26559,
	"./636.png": 19111,
	"./637.png": 14461,
	"./638.png": 50063,
	"./639.png": 74149,
	"./64.png": 42841,
	"./640.png": 80365,
	"./641-incarnate.png": 59129,
	"./641-therian.png": 74572,
	"./641.png": 93546,
	"./642-incarnate.png": 90408,
	"./642-therian.png": 4806,
	"./642.png": 45637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79047;